import { AES, enc } from "crypto-js";
// Validate url is of image or not
function isImage(url) {
	return /\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(url);
}

export {
	isImage
};

export function decryptData(encryptedData) {
  const ENCRYPT_KEY = localStorage.getItem("REACT_APP_ENCRYPT_KEY");
  const decryptedData = JSON.parse(AES.decrypt(encryptedData, ENCRYPT_KEY).toString(enc.Utf8));
  return decryptedData;
}

export const encryptData = async (data) => {
  const ENCRYPT_KEY = localStorage.getItem("REACT_APP_ENCRYPT_KEY");
  try {
    const encrypted = AES.encrypt(data, ENCRYPT_KEY).toString();
    return encrypted;
  } catch (error) {
    console.log("Encryption error:", error);
    throw error;
  }
};

export const maskSSN = (ssn) => {
    if (!ssn) return '';
    const ssnString = String(ssn); // Ensure ssn is treated as a string
    const digitsOnly = ssnString.replace(/\D/g, ''); // Remove non-digit characters
    if (digitsOnly.length === 9) {
        return `***-**-${digitsOnly.slice(-4)}`; // Mask except last 4 digits
    }
    return ssnString;
};

 export const getStepColors = (status) => {
    switch (status) {
      case "Approved":
        return "#4CAF50";
      case "InProcess":
        return "#ECB800";// Yellow for in-process
      case "NotApproved":
        return "#E44545";// Red for rejected
      case "NotStarted":
        return "#8B8D91"; // Red for rejected
      default:
        return "#8B8D91"; // Default grey
    }
  };

 export const calculateGlobalColors = (stages) => {
    const activeStep = stages.length - 1; // Assuming last step is active
    const activeStepStatus = stages[activeStep].status;
    // Get active step colors
    const { stepColor: activeColor } = getStepColors(activeStepStatus);
    // Get complete step colors (for all steps before active step)
    const { stepColor: completeColor } = getStepColors("Completed"); // Assuming completed steps have a specific color
    // Default color for future or unstarted steps
    const defaultColor = "#8B8D91";
    return { activeColor, completeColor, defaultColor };
  };

  export const langHeaders = () => ({
    headers: {
      'Accept-Language': 'en'
    }
});
